import { paths } from '@/utils/path'
import { Navigate, useSearchParams } from 'react-router-dom'

interface ContractsNewProps {
    children: React.ReactNode
}

const ContractsNewLayout: React.FC<ContractsNewProps> = ({ children }) => {
    const [search] = useSearchParams()
    const customerId = search.get('customer_id')

    if (!customerId) {
        return <Navigate to={paths.home} />
    }

    return <div>{children}</div>
}

export default ContractsNewLayout
